/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A value for a trend, either analog, boolean, enum, or null if the value is not present.
 */
export type TrendValue = {
  /**
   * The normalized value, if it was requested.
   */
  analogNormalizedValue?: number | undefined;
  /**
   * The analog value.
   */
  analogValue?: number | undefined;
  /**
   * The boolean value.
   */
  booleanValue?: boolean | undefined;
  /**
   * The enum value.
   */
  enumValue?: string | undefined;
  /**
   * RFC3339 formatted time in UTC
   */
  timestamp: Date;
};

/** @internal */
export const TrendValue$inboundSchema: z.ZodType<
  TrendValue,
  z.ZodTypeDef,
  unknown
> = z.object({
  analog_normalized_value: types.optional(types.number()),
  analog_value: types.optional(types.number()),
  boolean_value: types.optional(types.boolean()),
  enum_value: types.optional(types.string()),
  timestamp: types.date(),
}).transform((v) => {
  return remap$(v, {
    "analog_normalized_value": "analogNormalizedValue",
    "analog_value": "analogValue",
    "boolean_value": "booleanValue",
    "enum_value": "enumValue",
  });
});

export function trendValueFromJSON(
  jsonString: string,
): SafeParseResult<TrendValue, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TrendValue$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TrendValue' from JSON`,
  );
}
